import React from "react";
import "./Strategies.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faBullseye,
  faLayerGroup,
  faPenRuler,
  faGear,
  faArrowTrendUp,
} from "@fortawesome/free-solid-svg-icons";

const strategyItems = [
  {
    icon: faChartLine,
    title: "Research & Discovery",
    description:
      "We begin by deeply understanding your business, audience, and competitive landscape — so every decision is grounded in clarity, not assumption.",
  },
  {
    icon: faBullseye,
    title: "Brand Positioning",
    description:
      "We sharpen how your brand communicates online so visitors immediately grasp your value and feel confident choosing you over competitors.",
  },
  {
    icon: faLayerGroup,
    title: "Growth Roadmap",
    description:
      "We map out a structured plan connecting traffic, content, and conversions — so every moving part works toward the same clear goal.",
  },
  {
    icon: faPenRuler,
    title: "Content & Experience",
    description:
      "Pages, visuals, and copy are crafted to guide visitors naturally, reduce friction, and answer the questions they haven't asked yet.",
  },
  {
    icon: faGear,
    title: "Tools & Automation",
    description:
      "We set up forms, analytics, and follow-up workflows that ensure every lead is captured, tracked, and responded to without gaps.",
  },
  {
    icon: faArrowTrendUp,
    title: "Measure & Refine",
    description:
      "After launch, we track what's working and steadily improve — because a great result today should become an even better one tomorrow.",
  },
];

const Strategies = () => {
  return (
    <section className="sg-about" aria-label="Our strategy">
      <div className="sg-about-wrap">
        {/* Header */}
        <header className="sg-about-head">
          <span className="sg-about-kicker">Our Approach</span>
          <h2>Built on strategy, not guesswork</h2>
          <p>
            We follow a structured approach that removes confusion, aligns every
            decision with your business goals, and drives real, measurable
            growth — not just activity.
          </p>
        </header>

        {/* Grid */}
        <div className="sg-about-grid">
          {strategyItems.map((item) => (
            <article className="sg-about-card" key={item.title}>
              <div className="sg-about-icon">
                <FontAwesomeIcon icon={item.icon} />
              </div>

              <div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Strategies;
